import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		resetProducts: null,
		setQttProducts: ['qttProducts'],
	},
	{
		prefix: 'product-store/',
	}
)

const initialState = {
	qttProducts: 1,
}

const setQttProducts = (state = initialState, { qttProducts }) => ({
	...state,
	qttProducts,
})

const resetProducts = () => initialState

export default createReducer(initialState, {
	[Types.SET_QTT_PRODUCTS]: setQttProducts,
	[Types.RESET_PRODUCTS]: resetProducts,
})
